import React, {useEffect} from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaCheckCircle, FaMobileAlt, FaGlobe, FaShoppingCart, FaTools, FaCogs, FaArrowAltCircleRight } from "react-icons/fa";
import "aos/dist/aos.css";
import "../styles/Web.css"; // Custom styles

const WebAppDevelopment = () => {
   useEffect(() => {
        window.scrollTo(0, 0); // <-- This forces scroll to top
      }, []);
  return (
    <div className="telecom-support-section">
      <Container fluid className="py-5 text-dark">
        <Container data-aos="fade-up">
          <Row className="align-items-center">
            <Col md={6} data-aos="fade-right">
              <h3 className="fw-bold mb-3">Website and Application Development and Maintenance</h3>
              <p className="lead">
                Our team of experts specializes in developing and maintaining high-quality websites and applications. We use the latest technologies to create intuitive, user-friendly, and responsive digital solutions that cater to your business requirements. Whether you need a new website or want to enhance your existing one, we've got you covered.
              </p>
              <ul className="list-unstyled check-list">
                <li><FaCheckCircle className="me-2 text-success" /> Custom website design and development</li>
                <li><FaCheckCircle className="me-2 text-success" /> Mobile application development</li>
                <li><FaCheckCircle className="me-2 text-success" /> E-commerce solutions</li>
                <li><FaCheckCircle className="me-2 text-success" /> CMS development and integration</li>
                <li><FaCheckCircle className="me-2 text-success" /> Website maintenance and support</li>
              </ul>
            </Col>
            <Col md={6} data-aos="fade-left">
              <video
                src="/videos/webdev.mp4"
                className="network-video mt-4"
                autoPlay
                loop
                muted
                playsInline
              />
            </Col>
          </Row>

          {/* <div className="divider my-5"></div> */}

          <h4 className="fw text-center why-choose-heading why-choose-section">Our Key Services</h4>
          <Row className="g-4">
            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in">
                <Card.Body>
                  <FaGlobe className="icon" />
                  <Card.Title>Web Development</Card.Title>
                  <Card.Text>
                    Responsive and performance-optimized websites tailored to your brand.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="100">
                <Card.Body>
                  <FaMobileAlt className="icon" />
                  <Card.Title>App Development</Card.Title>
                  <Card.Text>
                    Cross-platform mobile app solutions for both Android and iOS.
                  </Card.Text>
                  {/* <a href="#app-development" className="read-more">
                    Read more <FaArrowAltCircleRight className="ms-1" />
                  </a> */}
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="200">
                <Card.Body>
                  <FaShoppingCart className="icon" />
                  <Card.Title>E-Commerce Solutions</Card.Title>
                  <Card.Text>
                    Complete e-commerce setup including cart, payments, and product management.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in">
                <Card.Body>
                  <FaCogs className="icon" />
                  <Card.Title>CMS Integration</Card.Title>
                  <Card.Text>
                    Seamless integration with popular content management systems.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="100">
                <Card.Body>
                  <FaTools className="icon" />
                  <Card.Title>Maintenance & Support</Card.Title>
                  <Card.Text>
                    Reliable updates, troubleshooting, and performance enhancements.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="200">
                <Card.Body>
                  <FaGlobe className="icon" />
                  <Card.Title>UI/UX Design</Card.Title>
                  <Card.Text>
                    Engaging and intuitive user interface designs for maximum user retention.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* <div className="divider my-5"></div> */}

          <h4 className="fw-bold text-center why-choose-heading why-choose-section">Why Choose Us?</h4>
          <ul className="list-unstyled row check-list-lg justify-content-center">
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Experienced full-stack developers</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Modern tech stack and frameworks</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Agile development process</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Scalable and secure architectures</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Continuous testing and quality assurance</li>
            <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Long-term maintenance partnerships</li>
          </ul>

          <div className="text-center mt-5">
            <Button variant="primary" href="/contact" className="cta-button">
              Contact Us
            </Button>
          </div>
        </Container>
      </Container>
    </div>
  );
};

export default WebAppDevelopment;
